import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams, useLocation } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { useAuth } from "../auth";

export default function FloatingChatButton() {
  const { tripId } = useParams();
  const { API, authHeaders, user } = useAuth();
  const location = useLocation();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!tripId || !user) return;
    const load = () => axios.get(`${API}/messages/unread-count`, { headers: authHeaders })
      .then((r) => setUnread(r.data.count || 0)).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [tripId, user]);

  if (!tripId || location.pathname.endsWith("/concierge")) return null;

  return (
    <Link to={`/trips/${tripId}/concierge`} data-testid="floating-chat"
          className="fixed z-40 right-4 flex items-center gap-2 pl-3.5 pr-4 py-2.5 rounded-full font-body text-[12px] uppercase tracking-[0.14em] transition-opacity hover:opacity-90"
          style={{ bottom: "calc(88px + env(safe-area-inset-bottom))", background: "var(--tcm-navy)", color: "var(--tcm-cream)", border: "1px solid var(--tcm-gold)" }}>
      <div className="relative">
        <MessageCircle size={16} strokeWidth={1.5} />
        {unread > 0 && (
          <span data-testid="floating-unread" className="absolute -top-1.5 -right-2 min-w-[16px] h-[16px] px-1 flex items-center justify-center text-[9px] rounded-full"
                style={{ background: "var(--tcm-gold)", color: "var(--tcm-navy)" }}>
            {unread > 9 ? "9+" : unread}
          </span>
        )}
      </div>
      Chat
    </Link>
  );
}
